import { Injectable, Injector, Inject } from '@angular/core';

import { ToastrService } from 'ngx-toastr';

import * as bowser from 'bowser';

@Injectable()
export class BrowserDetectService {

	// private toastr: ToastrService;

	constructor(
		@Inject(Injector) private injector: Injector,
	) {
	}

	getBrowserInfo() {
		const info = bowser.getParser(window.navigator.userAgent).getBrowser(); // info.name info.version
		return info;
	}

	warning(info) {
		const brName = info.name.toLowerCase();
		if (brName !== 'chrome' && brName !== 'firefox') {
			const toastr = this.injector.get(ToastrService);
			toastr.warning(`Some of the features are not supported in ${info.name} currently. <br>
			Please visit the website in Chrome or Firefox. Thanks!`, '', {
				enableHtml: true,
				timeOut: 100000
			});
		}
	}
}
